import { render, staticRenderFns } from "./editField.vue?vue&type=template&id=5abfdc72&scoped=true"
import script from "./editField.vue?vue&type=script&lang=js"
export * from "./editField.vue?vue&type=script&lang=js"
import style0 from "./editField.vue?vue&type=style&index=0&id=5abfdc72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abfdc72",
  null
  
)

export default component.exports